/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from 'react';
import { MainTabLabels, PaidBy } from '../../core';



export interface CustomProps {
  tabName: PaidBy;
  tabChangeHandler: (tabName: PaidBy) => void;
  pendingCount?: number;
  requestedCount?: number;
  approvedCount?: number;
  completedCount?: number;
}

const MainTabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<PaidBy>(
    props.tabName || PaidBy.Client
  );

  const setElementActive = (tabValue: PaidBy) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  return (
    <ul
      className="d-flex list-unstyled tab-underline font-sm font-weight-semibold text-nowrap overflow-auto m-0"
      id="activity-tab"
      role="tablist"
    >
      {Object.entries(PaidBy).map(([key, value]) => {
        const label = MainTabLabels[key as keyof typeof MainTabLabels];
        return (
          <li className="nav-item pr-4 pl-4" role="presentation">
            <a
              className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                tabName === value ? 'active' : ''
              }`}
              onClick={(e) => setElementActive(value)}
            >
              <span className="py-1 d-inline-flex">{label}</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default MainTabs;
